// The Arabic voice (BUILD-SPEC rule G9, the owner's choice of 23 October 2026: DECISIONS 107): every Arabic name and
// every hadith and scholar's words the app shows can be heard, read by a man's voice or, if chosen in Settings, a
// woman's. The Quran is never read by it. Clips are rendered offline (Chatterbox Multilingual) into
// public/audio/arabic/<voice>/<id>.m4a, listed in public/audio/arabic/manifest.json, and played by the narrator.

/** A clip's name for an Arabic text: a short hash of the text as shown (NFC), so the same words always map to the
 *  same recording (FNV-1a, 32 bits). */
export function clipId(text: string): string {
  const s = text.normalize('NFC').trim();
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

export type ArabicVoice = 'm' | 'f';
/** The narrator's key for an Arabic text in a voice. */
export const arabicKey = (text: string, voice: ArabicVoice) => `ar/${voice}/${clipId(text)}`;
